module.exports = leConfiguration;